import React from 'react';

const faqs = [
  {
    category: 'General',
    items: [
      {
        question: '1. What does CalcSafe do?',
        answer:
          'CalcSafe is a private Calculator Locker app that looks like a calculator but securely hides your photos, videos, files, and more.',
      },
      {
        question: '2. How do I access my hidden files?',
        answer:
          "Enter your secret PIN on the calculator screen and tap the '=' icon to access your vault.",
      },
      {
        question: '3. Is my data safe?',
        answer:
          'Yes, all your hidden data is stored securely within the app and protected by your password.',
      },
    ],
  },
  {
    category: 'File & Media Protection',
    items: [
      {
        question: '4. How do I hide photos, videos, or files?',
        answer:
          "Open CalcSafe → Click the '+' icon → Choose media type → Select file/s you want to hide → Tap 'Hide'. All your media files will be securely hidden from the public eye.",
      },
      {
        question: '5. Can I recover deleted files?',
        answer:
          'Yes, deleted files are moved to the Trash Bin, where you can restore them anytime.',
      },
      {
        question: '6. How long are files stored in Trash?',
        answer:
          'You get options for how long you can keep your files in the Trash. You can choose from 3 days, 7 days, 15 days, 30 days, or 40 days.',
      },
      {
        question: '7. Can I share hidden files?',
        answer: 'Yes, you can share your hidden files easily and securely.',
      },
    ],
  },
  {
    category: 'App Lock',
    items: [
      {
        question: '8. What is App Lock?',
        answer:
          'Any app that you want to hide or keep hidden can be PIN-protected with the App Lock feature.',
      },
      {
        question: '9. Will the app/s be permanently locked?',
        answer:
          'The app will be locked for as long as you want it. You can lock or unlock it according to your preference.',
      },
    ],
  },
  {
    category: 'Music Player',
    items: [
      {
        question: '10. Can CalcSafe hide audio files?',
        answer:
          'Yes, you can hide your audio files securely and also play them seamlessly within the app.',
      },
      {
        question: '11. Can I play hidden audio files?',
        answer:
          'Yes, the built-in Music Player allows you to play audio files directly within the vault.',
      },
    ],
  },
  {
    category: 'Notes',
    items: [
      {
        question: '12. Can I store private notes?',
        answer: 'Yes, you can create and store secure notes inside the app.',
      },
      {
        question: '13. Are my notes protected?',
        answer:
          'Yes, notes are securely hidden in your vault password. You can also add extra protection with a lock.',
      },
    ],
  },
  {
    category: 'Downloader & Browser',
    items: [
      {
        question: '14. What is the in-app browser used for?',
        answer:
          'You can browse privately and download files directly into your vault.',
      },
      {
        question: '15. Is browsing history saved?',
        answer: "Yes, but only inside the app's private browser history.",
      },
    ],
  },
  {
    category: 'Camera',
    items: [
      {
        question: '16. What is the private camera feature?',
        answer:
          "You can capture photos/videos directly into the vault. These images or videos will not appear in your phone's gallery.",
      },
    ],
  },
  {
    category: 'Customization & Disguise',
    items: [
      {
        question: '17. What is Icon Disguise?',
        answer:
          'You get multiple different calculator skins to change the app icon to keep it hidden.',
      },
      {
        question: '18. Can I customize the app theme?',
        answer:
          'Yes, you can choose from different themes and customize the interface.',
      },
    ],
  },
  {
    category: 'Security & Access',
    items: [
      {
        question: '19. What if I forget my password?',
        answer:
          "In case you forget your password, you can type '11223344' to enter the vault. Use the password recovery option (if enabled) or your security question to reset it.",
      },
      {
        question: '20. Can I change my password?',
        answer: 'Yes, go to Settings → Reset Password.',
      },
      {
        question: '21. Will my data be deleted if I uninstall the app?',
        answer:
          'Your hidden data is stored in the .Files folder. Even if you delete the app, you can restore your data from here. But if you delete this folder, no data can be retrieved.',
      },
    ],
  },
  {
    category: 'Extra Features',
    items: [
      {
        question: '22. What does File Share do?',
        answer:
          'You can share your media files on the go. To share your hidden files, you’ll have to unhide them before sharing.',
      },
      {
        question: '23. Does the app support multiple file types?',
        answer:
          'Yes, you can hide images, videos, documents, audio, and more.',
      },
    ],
  },
];

const CalcSafe = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-2">Frequently Asked Questions</h1>
      <p className="text-xl font-semibold text-gray-800 mb-4">
        CalcSafe – Hider &amp; Locker
      </p>
      <p className="mb-6">
        If you have any queries for CalcSafe or face any difficulty using it, please write to us at{' '}
        <a
          href="mailto:feedback@appspacesolutions.in"
          className="text-blue-600 underline"
        >
          feedback@appspacesolutions.in
        </a>
        .
      </p>
      {faqs.map((section, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-xl font-semibold mb-3">{section.category}</h2>
          <ul className="space-y-4">
            {section.items.map((item, i) => (
              <li key={i}>
                <p className="font-bold">{item.question}</p>
                <div className="text-gray-700">{item.answer}</div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default CalcSafe;
